function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M452.611,24.82c-3.605-2.844-8.314-3.877-12.781-2.813L229.16,72.4L18.49,22.008c-4.466-1.065-9.176-0.032-12.781,2.813 C2.104,27.666,0,32.005,0,36.597v333.899c0,6.94,4.761,12.974,11.511,14.589c2.241,0.536,213.117,50.985,214.402,51.27 c1.589,0.353,3.276,0.368,3.246,0.368h0.001c1.126,0,2.555-0.188,3.489-0.411l214.161-51.227c6.75-1.615,11.51-7.648,11.51-14.589 V36.597C458.32,32.005,456.216,27.665,452.611,24.82z M212.161,318.549c-1.927,8.056-10.019,13.025-18.078,11.1L43.098,293.533 c-8.057-1.928-13.026-10.021-11.099-18.078s10.02-13.023,18.078-11.1l150.985,36.115 C209.119,302.398,214.088,310.492,212.161,318.549z M212.161,253.049c-1.927,8.056-10.019,13.025-18.078,11.1L43.098,228.033 c-8.057-1.928-13.026-10.021-11.099-18.078s10.02-13.023,18.078-11.1l150.985,36.115 C209.119,236.898,214.088,244.992,212.161,253.049z M212.161,187.549c-1.927,8.056-10.019,13.025-18.078,11.1L43.098,162.533 c-8.057-1.928-13.026-10.021-11.099-18.078s10.02-13.023,18.078-11.1l150.985,36.115 C209.119,171.398,214.088,179.492,212.161,187.549z M416.062,293.533l-150.985,36.115c-8.058,1.926-16.151-3.042-18.078-11.1 c-1.927-8.057,3.042-16.15,11.099-18.078l150.985-36.115c8.059-1.924,16.151,3.042,18.078,11.1 C429.088,283.512,424.119,291.605,416.062,293.533z M416.062,228.033l-150.985,36.115c-8.058,1.926-16.151-3.042-18.078-11.1 c-1.927-8.057,3.042-16.15,11.099-18.078l150.985-36.115c8.059-1.925,16.151,3.042,18.078,11.1 C429.088,218.012,424.119,226.105,416.062,228.033z M416.062,162.533l-150.985,36.115c-8.058,1.926-16.151-3.042-18.078-11.1 c-1.927-8.057,3.042-16.15,11.099-18.078l150.985-36.115c8.059-1.926,16.151,3.042,18.078,11.1 C429.088,152.512,424.119,160.605,416.062,162.533z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 458.32 458.32",
    style: {
      enableBackground: "new 0 0 458.32 458.32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.42eae963.svg";
export { ForwardRef as ReactComponent };